// TODO: This code could probably be cleaned up a lot
class DetailsDropdown extends HTMLElement {
  constructor() {
    super();
    this.detailsToShow = this.lastElementChild;
    this.trigger = this.firstElementChild;
    this.caret = this.querySelector('.js-icon-caret');
    this.opened = false;

    this.onClick = this.onClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    this.trigger.addEventListener('click', this.onClick);
    this.trigger.addEventListener('keydown', this.onKeyDown);
    this.trigger.addEventListener('focus', this.onFocus);
    this.trigger.addEventListener('blur', this.onBlur);

    this.childItems = Array.from(this.querySelectorAll('a, details-dropdown'))
    // filter out so that it only grabs its own children (not recursive dropdowns)
      .filter((node) => node.parentNode.closest('details-dropdown') === this);

    this.childItems.forEach((item) => {
      // Add event listener to all children (dropdowns or links) that will close any sibling dropdowns on focus
      item.addEventListener('focus', this.onChildFocus.bind(this));
      // Listen to esc or tab on any child item
      item.addEventListener('keydown', this.onChildKeyDown.bind(this));
    });

    this.addEventListener('mouseover', this.open.bind(this));
    // this.addEventListener('mouseout', this.close.bind(this));

    this.addEventListener('mouseout', (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.close();
      }
    });

    this.detailsToShow.addEventListener('transitionend', this.onTransitionEnd);
  }

  /** Fires when you tab onto any item in the dropdown */
  onChildFocus(event) {
    this.childItems.forEach((child) => {
      if (child.tagName === 'DETAILS-DROPDOWN') {
        child.close();
      }
    });
  }

  /** Fires when you press anything on any item in the dropdown */
  onChildKeyDown(event) {
    // Close the deepest dropdown if you press escape
    if (event.code === 'Escape') { // && this.childItems.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation(); // Stop it from bubbling out and closing any parent dropdowns

      this.close();
      // Focus on the dropdown trigger
      this.trigger.focus();
    } else if (event.code === 'Tab') {
      // Close the dropdown if you tab off the last item in the dropdown...
      if (event.currentTarget === this.childItems[this.childItems.length - 1] && !event.shiftKey
        // ...and is not an open dropdown itself
        && !(event.currentTarget.tagName === 'DETAILS-DROPDOWN' && event.currentTarget.hasAttribute('open'))
      ) {
        // Stop it from bubbling out and closing any parent dropdowns
        event.stopPropagation();
        event.preventDefault();
        this.close();
        this.trigger.focus();
      } // Close the dropdown if you shift+tab off the first item in the dropdown
      else if (event.currentTarget === this.childItems[0] && event.shiftKey) {
        // Stop it from bubbling out and closing any parent dropdowns
        event.stopPropagation();
        event.preventDefault();
        this.close();
        this.trigger.focus();
      }
    }
  }

  onClick(event) {
    if (event.type === 'click' || event.code === 'Space') {
      event.preventDefault();
      this.toggle();
    }
  }

  /** On key down when focused on the dropdown itself */
  onKeyDown(event) {
    if (event.code === 'Enter') {
      event.preventDefault();
      this.toggle();
    } else if (event.code === 'Escape') {
      event.preventDefault();
      this.close();
    } else if (event.code === 'ArrowDown') {
      event.preventDefault();
      this.open();
    } else if (event.code === 'ArrowUp') {
      event.preventDefault();
      this.close();
    }
  }

  onFocus() {
    // console.log('focus');
    // this.trigger.classList.add('focus');
  }

  onBlur() {
    // console.log('blur');
    // this.trigger.classList.remove('focus');
  }

  onTransitionEnd() {
    if (!this.opened) {
      this.detailsToShow.style.display = 'none';
    }
  }

  toggle() {
    this.opened ? this.close() : this.open();
  }

  open() {
    this.detailsToShow.style.display = 'block';

    // If the dropdown has hover-svg class, we don't want to rotate the caret
    if (this.caret && !this.classList.contains('hover-svg')) {
      this.caret.style.transform = 'rotate(180deg)';
    }

    this.setAttribute('open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.opened = true;
  }

  close() {
    // If the dropdown has hover-svg class, we don't want to rotate the caret
    if (this.caret && !this.classList.contains('hover-svg')) {
      this.caret.style.transform = 'rotate(0deg)';
    }

    this.detailsToShow.style.display = 'none';
    this.removeAttribute('open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.opened = false;

    // Close any nested dropdowns
    this.querySelectorAll('[open]').forEach((dropdown) => {
      dropdown.close();
    });
  }
}

customElements.define('details-dropdown', DetailsDropdown);